import { Suspense } from 'react';
import { Skeleton } from '@mui/material';
import GlobalErrorBoundary from 'components/GlobalErrorBoundary';
import GridErrorBoundaryFallback from './GridErrorBoundaryFallback';

interface GridWrapperProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

const SuspenseBoundary = ({ children, fallback }: GridWrapperProps) => {
  return (
    <GlobalErrorBoundary FallbackComponent={GridErrorBoundaryFallback}>
      <Suspense
        fallback={fallback ??
          <Skeleton
            width={'100%'}
            height={'40px'}
            sx={{ transform: 'translateY(0)', borderRadius: '8px' }}
          />
        }
      >
        {children}
      </Suspense>
    </GlobalErrorBoundary>
  );
};

export default SuspenseBoundary;